import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ea855c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

import { ref, Ref, watch, inject, onMounted } from "vue";
import { AppConfigServiceCtx } from "@/api";
import AppConfigService from "@/services/AppConfigService";
import { PlatformPolicies } from "@/interfaces/PlatformPolicies";


export default /*#__PURE__*/_defineComponent({
  __name: 'PlatformPoliciesDoctorView',
  setup(__props) {

const policiesContent = ref();

const appConfigService: AppConfigService | undefined =
  inject(AppConfigServiceCtx);

onMounted(async () => {
  const pc: PlatformPolicies | undefined =
    await appConfigService?.fetchPlatformPoliciesForDoctor();
  if (pc != null && pc.content) {
    policiesContent.value = pc.content;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", null, [
    _createElementVNode("span", { innerHTML: policiesContent.value }, null, 8, _hoisted_1)
  ]))
}
}

})